// import Select from 'react-select';
import DataGrid from 'react-data-grid';
import ReactPaginate from 'react-paginate';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import ContentSpinner from 'components/ui/ContentSpinner';

import { useTranslation } from 'react-i18next';

const DataGridWithPagination = ({ grid = {}, pagination = {}, loading, sortColumns = [], onSortColumnsChange, onChangePageSize, onRowClick }) => {
  const { t } = useTranslation();
  const { columns = [], rows = [] } = grid;
  const { count = 0, pageSize = 50, onPageChange, current_page } = pagination;

  if (loading) {
    return <ContentSpinner />;
  }

  const pageCount = Math.ceil(count / pageSize);

  const pageChangeHandle = ({ selected }) => {
    const page = selected + 1;

    if (typeof onPageChange === 'function') {
      onPageChange(page);
    }
  };

  const renderPagination = () => {
    if (pageCount < 1) {
      return null;
    }

    // const pageSizes = [10, 25, 50, 100];
    // const marginTop = pageSize > 10 ? 'mt-n4' : 'mt-n4';
    const paginateClassName = 'page-item mt-n2';
    const paginateLinkClassName = 'page-link';

    return (
      <div className="mt-4 pb-2 d-flex justify-content-between">
        <ReactPaginate
          previousLabel={t('keys.previous')}
          nextLabel={t('keys.next')}
          pageCount={pageCount}
          onPageChange={pageChangeHandle}
          containerClassName={'pagination'}
          activeClassName={'active'}
          breakClassName={paginateClassName}
          breakLabel={<button className={paginateLinkClassName}>...</button>}
          pageClassName={paginateClassName}
          previousClassName={paginateClassName}
          nextClassName={paginateClassName}
          pageLinkClassName={paginateLinkClassName}
          previousLinkClassName={paginateLinkClassName}
          nextLinkClassName={paginateLinkClassName}
          forcePage={current_page - 1}
        />

        {/* <div className={`form-group ${marginTop} w-25`}>
          <label htmlFor="">{t('pagination.items_per_page')}:</label>
          <Select
            menuPlacement="top"
            options={[
              ...pageSizes.map(i => {
                return { value: i, label: i };
              }),
            ]}
            placeholder={pageSize}
            onChange={onChangePageSize}
          />
        </div> */}
      </div>
    );
  };

  const renderGrid = () => {
    if (!rows.length) {
      return <NoRecords />;
    }

    return (
      <DataGrid
        columns={columns}
        rows={rows || []}
        rowHeight={50}
        className="data-grid rdg-light with-pagination"
        emptyRowsView={NoRecords}
        onRowClick={onRowClick}
        sortColumns={sortColumns}
        onSortColumnsChange={onSortColumnsChange}
      />
    );
  };

  return (
    <div>
      {renderGrid()}
      {renderPagination()}
    </div>
  );
};

export default DataGridWithPagination;
